import { HalfaLaserBox } from "@/components/HalfaLaserStrip";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useMeta } from "@/lib/meta";
import { ProductCard } from "@/pages/Home";

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("categoria") || "";
  const q = params.get("q") || "";
  const meta = useMeta();
  const [products, setProducts] = useState(null);
  useEffect(() => {
    setProducts(null);
    api.get("/products", { params: { ...(cat && { category: cat }), ...(q && { q }) } }).then((r) => setProducts(r.data));
  }, [cat, q]);
  const chip = (id, name) => (
    <button key={id || "all"} data-testid={`category-filter-${id || "all"}`} onClick={() => setParams(id ? { categoria: id } : {})}
      className={`press h-9 px-4 rounded-full text-sm border ${cat === id ? "bg-brand-navy text-white border-brand-navy" : "bg-white border-slate-200 hover:border-brand-navy"}`}>{name}</button>
  );
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <div className="font-mono text-[11px] tracking-widest text-slate-500">CATALOGO</div>
      <h1 className="text-5xl sm:text-6xl font-extrabold uppercase mb-8">{q ? <>Risultati per “{q}”</> : "Scegli il tuo timbro"}</h1>
      {q && <button data-testid="catalog-clear-search" onClick={() => setParams(cat ? { categoria: cat } : {})} className="-mt-5 mb-6 text-sm font-semibold text-brand-navy hover:underline">× Cancella ricerca</button>}
      <div className="flex flex-wrap gap-2 mb-10">
        {chip("", "Tutti")}
        {meta?.categories.map((c) => chip(c.id, c.name))}
      </div>
      {products === null ? (
        <div className="text-slate-500">Caricamento…</div>
      ) : products.length === 0 ? (
        <div className="text-slate-500" data-testid="catalog-empty">{q ? "Nessun prodotto trovato: prova con il modello (es. 4912) o la misura (es. 14x38)." : "Nessun timbro in questa categoria."}</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="catalog-grid">
          {products.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
        </div>
      )}
      <HalfaLaserBox where="catalog" />
    </div>
  );
}
